module.exports = __webpack_public_path__ + "img/freewave2_feature_02.0caa40f6.jpg";